// extracted by mini-css-extract-plugin
module.exports = {"down":"MoveDown_down__34fqe","btn":"MoveDown_btn__QbSnC","blink":"MoveDown_blink__4O6qj","turn":"MoveDown_turn__23046"};